import React from "react";

export const EmotionPreview = React.lazy(
  () => import("@/features/emotion-preview/pages/EmotionPreviewPage.tsx"),
);
